// Field schemas for admin CRUD. Types: text, textarea, html, number, bool, select, tags, list, faq, image
export const TOPIC_OPTIONS = ["Mindset", "Discipline", "Resilience", "Leadership", "Relationships", "Intentional Living"];
export const PRINCIPLE_CATS = ["Mindset", "Discipline", "Leadership", "Resilience", "Relationships", "Growth", "Purpose", "Success", "Productivity", "Character"];
export const RESOURCE_CATS = ["Guides", "Workbooks", "Checklists", "Assessments", "Templates", "Downloads", "Tools"];

export const SCHEMAS = {
  articles: {
    label: "Articles",
    endpoint: "/articles",
    listQuery: { status: "all" },
    columns: ["title", "category", "status", "featured"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "slug", label: "Slug", type: "text", help: "Leave blank to auto-generate" },
      { key: "subtitle", label: "Subtitle", type: "text" },
      { key: "excerpt", label: "Excerpt", type: "textarea" },
      { key: "body", label: "Body (HTML)", type: "html" },
      { key: "featured_image", label: "Featured Image URL", type: "image" },
      { key: "category", label: "Category", type: "select", options: TOPIC_OPTIONS },
      { key: "tags", label: "Tags", type: "tags" },
      { key: "author", label: "Author", type: "text", default: "Lance Cervantes" },
      { key: "reading_time", label: "Reading time (min)", type: "number", default: 5 },
      { key: "publication_date", label: "Publication Date (ISO)", type: "text" },
      { key: "featured", label: "Featured", type: "bool" },
      { key: "status", label: "Status", type: "select", options: ["draft", "published"], default: "draft" },
      { key: "reflection_question", label: "Reflection Question (THINK ABOUT IT)", type: "textarea" },
      { key: "practical_application", label: "Practical Application (APPLY IT)", type: "textarea" },
      { key: "related_book", label: "Related Book (slug)", type: "text" },
      { key: "related_resource", label: "Related Resource (slug)", type: "text" },
      { key: "seo_title", label: "SEO Title", type: "text" },
      { key: "seo_description", label: "SEO Description", type: "textarea" },
      { key: "social_image", label: "Social Image URL", type: "image" },
    ],
    ai: true,
  },
  principles: {
    label: "Principles",
    endpoint: "/principles",
    listQuery: { status: "all" },
    columns: ["title", "category", "status", "featured"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "statement", label: "Core Principle / Statement", type: "textarea" },
      { key: "explanation", label: "Explanation", type: "textarea" },
      { key: "practical_application", label: "Practical Application", type: "textarea" },
      { key: "reflection_question", label: "Reflection Question", type: "textarea" },
      { key: "category", label: "Category", type: "select", options: PRINCIPLE_CATS },
      { key: "related_article", label: "Related Article (slug)", type: "text" },
      { key: "featured", label: "Featured", type: "bool" },
      { key: "status", label: "Status", type: "select", options: ["draft", "published"], default: "published" },
    ],
  },
  books: {
    label: "Books",
    endpoint: "/books",
    listQuery: { status: "all" },
    columns: ["title", "status", "featured", "price"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "subtitle", label: "Subtitle", type: "text" },
      { key: "cover_image", label: "Cover Image URL", type: "image" },
      { key: "short_description", label: "Short Description", type: "textarea" },
      { key: "long_description", label: "Long Description (HTML)", type: "html" },
      { key: "key_themes", label: "Key Themes", type: "tags" },
      { key: "who_its_for", label: "Who It's For", type: "textarea" },
      { key: "benefits", label: "Benefits", type: "list" },
      { key: "table_of_contents", label: "Table of Contents", type: "list" },
      { key: "faq", label: "FAQ", type: "faq" },
      { key: "author_section", label: "Author Section", type: "textarea" },
      { key: "primary_cta", label: "Primary CTA text", type: "text", default: "Get the Book" },
      { key: "purchase_url", label: "External Purchase URL (optional)", type: "text" },
      { key: "price", label: "Price (USD)", type: "number" },
      { key: "featured", label: "Featured", type: "bool" },
      { key: "status", label: "Status", type: "select", options: ["published", "coming_soon", "draft"], default: "published" },
      { key: "seo_title", label: "SEO Title", type: "text" },
      { key: "seo_description", label: "SEO Description", type: "textarea" },
    ],
  },
  resources: {
    label: "Resources",
    endpoint: "/resources",
    listQuery: { status: "all" },
    columns: ["title", "category", "is_free", "status"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "description", label: "Description", type: "textarea" },
      { key: "category", label: "Category", type: "select", options: RESOURCE_CATS },
      { key: "image", label: "Image URL", type: "image" },
      { key: "is_free", label: "Free", type: "bool", default: true },
      { key: "download_url", label: "Download URL / CTA", type: "text" },
      { key: "requires_lead_capture", label: "Requires Lead Capture", type: "bool", default: true },
      { key: "status", label: "Status", type: "select", options: ["published", "draft"], default: "published" },
      { key: "seo_title", label: "SEO Title", type: "text" },
      { key: "seo_description", label: "SEO Description", type: "textarea" },
    ],
  },
  programs: {
    label: "Programs",
    endpoint: "/programs",
    listQuery: {},
    columns: ["title", "track", "status"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "track", label: "Track", type: "select", options: ["LEARN", "EXPERIENCE", "APPLY"] },
      { key: "description", label: "Description", type: "textarea" },
      { key: "image", label: "Image URL", type: "image" },
      { key: "cta_text", label: "CTA Text", type: "text", default: "Learn More" },
      { key: "cta_url", label: "CTA URL", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["coming_soon", "published"], default: "coming_soon" },
    ],
  },
};
